<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    @if (unreadCount > 0) {
        <span
            class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center"
        >
            <span
                class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-teal-600 px-1 text-xs font-medium text-indigo-50"
            >
                {{ unreadCount }}
            </span>
        </span>
    }
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <div class="notification-panel-shell">
        <app-notification-panel
            [notifications]="panelNotifications"
            (notificationsChange)="onPanelNotificationsChange($event)"
            (readRequested)="onPanelNotificationRead($event)"
            (markAllRequested)="onPanelMarkAllRead()"
            (deleteRequested)="onPanelNotificationDelete($event)"
        ></app-notification-panel>
    </div>
</ng-template>
